import Vue from 'vue';

// init app
const VueApp = new Vue({
});

export { VueApp as default };